module.exports = new __parcel__URL__("creating-rem-lezar.ba8e502a.jpg").toString();